import { CSpinner } from '@coreui/react';
import React, {useState, useEffect} from 'react';
import { initLang } from 'src/language/lang';
const LanguageLoader = ({ children }) => {
  const [isLanguageLoaded, setIsLanguageLoaded] = useState(false);

  useEffect(() => {
    initLang()
      .then(() => setIsLanguageLoaded(true))
      .catch(err => {
        console.error("Lỗi tải ngôn ngữ:", err);
        setIsLanguageLoaded(true); // Vẫn cho phép render dù lỗi
      });
  }, []);

  if (!isLanguageLoaded) {
    return (
      <div className="pt-3 text-center">
        <CSpinner color="primary" variant="grow" />
      </div>
    );
  }

  return children;
};
export default LanguageLoader;